export default class POSMCategory {
  constructor(name, data, id, inputType) {
    this.name = name;
    this.data = data;
    this.id = id;
    this.inputType = inputType;
  }
}